import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'vnSearch', standalone: false })
export class VnSearchPipe implements PipeTransform {
  transform<T extends Record<PropertyKey, any>>(
    items: T[],
    term: string,
    fields: PropertyKey[] = []
  ): T[] {
    if (!Array.isArray(items) || !term?.trim()) return items;
    const q = this.norm(term);
    return items.filter((it: any) => {
      if (!fields.length) return this.norm(String(it)).includes(q);
      return fields.some((f: PropertyKey) => {
        const val = it?.[f as any];
        return val != null && this.norm(String(val)).includes(q);
      });
    });
  }
private norm(s: string): string {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '');
  }
}
